import Request from 'api/Request';
import { AxiosResponse } from 'axios';

type ReturnType = Promise<AxiosResponse<{ url: string }>>;

const createCheckoutSession = (
    return_url: string,
    organization: string,
    price?: string,
    flow?: string,
): ReturnType => {
    return Request.post(`/organizations/${organization}/checkout-session`, {
        return_url: return_url,
        price,
        flow,
    });
};
export default createCheckoutSession;
